import { useQuery } from "react-query";
import { Spinner } from "component-library";
import { BillingUser } from "translations/src/models/billing";
import Layout from "app-shell/Layout/Layout";
import CDWrapper from "./variants/CDWrapper";
import GradTransferWrapper from "./variants/GradTransferWrapper";
import PerformerWrapper from "./variants/PerformerWrapper";
import ChangeWrapper from "./variants/ChangeWrapper";
import useGetUserType from "./hooks/useGetUserType";
import { NonJoiningBillingUser } from "./types";
import "../Checkout/styles.scss";
import {
  getRecurlyDetails,
  IBillingApiResponse,
  MY_SUBSCRIPTION_QK,
} from "services/api/BillingApi/BillingApi";
import { SubscriptionCalculatedStatus } from "app/constants";
import { BrazeCustomEvents } from "shared-services";

const renderComponentMap: Record<NonJoiningBillingUser, any> = {
  [BillingUser.Casting]: CDWrapper,
  [BillingUser.Performer]: PerformerWrapper,
  [BillingUser.YoungPerformer]: PerformerWrapper,
  [BillingUser.GraduateTransfer]: GradTransferWrapper,
  [BillingUser.Graduate]: PerformerWrapper,
  [BillingUser.PerformerChange]: ChangeWrapper,
};

const CheckoutPageWrapper = ({ children }: { children?: React.ReactNode }) => {
  const { data: mySubscriptionData, isLoading } = useQuery<
    IBillingApiResponse | undefined
  >({
    queryKey: MY_SUBSCRIPTION_QK,
    queryFn: async () => await getRecurlyDetails(),
    cacheTime: 0,
  });

  const userType = useGetUserType();

  const isRenewal =
    mySubscriptionData?.subscription?.calculatedStatus ===
    SubscriptionCalculatedStatus.Renewing;

  const brazeSubscriptionPurchaseType = isRenewal
    ? BrazeCustomEvents.SubscriptionPurchaseRenewal
    : BrazeCustomEvents.SubscriptionPurchaseReactivation;
  const brazeAddOnPurchaseType = isRenewal
    ? BrazeCustomEvents.AddOnBundlePurchaseRenewal
    : BrazeCustomEvents.AddOnBundlePurchaseReactivation;

  const Component = renderComponentMap[userType as NonJoiningBillingUser];

  if (!userType || isLoading) return <Spinner />;

  return (
    <Layout hideFooter contentContainerCustomClassName="h-full">
      <div className="pt-2 md:px-2 checkout-page">
        {children ?? (
          <Component
            brazeSubscriptionPurchaseType={brazeSubscriptionPurchaseType}
            brazeAddOnPurchaseType={brazeAddOnPurchaseType}
          />
        )}
      </div>
    </Layout>
  );
};

export default CheckoutPageWrapper;
